<h1 class="error title">{{ 'unauthorized.title' | translate }}</h1>
<p class="error detail">{{ 'unauthorized.detail' | translate }}</p>
<p class="error explanation">{{ 'unauthorized.explanation' | translate }}</p>

<davinci-button class="button" (click)="requestAccess()">{{ 'unauthorized.request' | translate }}</davinci-button>
